export const actionTypes = {
	// Utils
	USER_LOGOUT: 'USER_LOGOUT',
	SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
	SET_SESSON_TOKEN: 'SET_SESSON_TOKEN',
	SET_EMAIL_FOR_LOGIN: 'SET_EMAIL_FOR_LOGIN',
	SET_EMAIL_FOR_FORGET_PASSWORD: 'SET_EMAIL_FOR_FORGET_PASSWORD',
	SET_USER_TYPE: 'SET_USER_TYPE',
	SET_USER_ID: 'SET_USER_ID',
	SET_BRAND_CAMPAIGN_CREATION_STEP: 'SET_BRAND_CAMPAIGN_CREATION_STEP',
	SET_BRAND_CAMPAIGN_CREATION_DATA: 'SET_BRAND_CAMPAIGN_CREATION_DATA',
	SET_IS_MERGE_POPUP_ACTIVE: 'SET_IS_MERGE_POPUP_ACTIVE',
	SET_OPT_AND_SUBMIT_CONTENT_RESPONSE: 'SET_OPT_AND_SUBMIT_CONTENT_RESPONSE',
	SET_STREAM_VIDEO_RESPONSE: 'SET_STREAM_VIDEO_RESPONSE',
	SET_YOUTUBE_ACCOUNT_ACCESS_TYPE: 'SET_YOUTUBE_ACCOUNT_ACCESS_TYPE',
	SET_PARTICIPATED_CAMPAIGN_DETAILS: 'SET_PARTICIPATED_CAMPAIGN_DETAILS',

	// Public
	GET_ALL_COUNTRAY_REQUEST: 'GET_ALL_COUNTRAY_REQUEST',
	GET_ALL_COUNTRAY_SUCCESS: 'GET_ALL_COUNTRAY_SUCCESS',
	GET_ALL_COUNTRAY_FAILURE: 'GET_ALL_COUNTRAY_FAILURE',
	GET_ALL_COUNTRAY_RESET: 'GET_ALL_COUNTRAY_RESET',
	GET_ALL_COUNTRAY_RESET_ALL: 'GET_ALL_COUNTRAY_RESET_ALL',

	// Auth
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_FAILURE: 'LOGIN_FAILURE',
	LOGIN_RESET: 'LOGIN_RESET',
	LOGIN_RESET_ALL: 'LOGIN_RESET_ALL',

	GOOGLE_USER_LOGIN_REQUEST: 'GOOGLE_USER_LOGIN_REQUEST',
	GOOGLE_USER_LOGIN_SUCCESS: 'GOOGLE_USER_LOGIN_SUCCESS',
	GOOGLE_USER_LOGIN_FAILURE: 'GOOGLE_USER_LOGIN_FAILURE',
	GOOGLE_USER_LOGIN_RESET: 'GOOGLE_USER_LOGIN_RESET',
	GOOGLE_USER_LOGIN_RESET_ALL: 'GOOGLE_USER_LOGIN_RESET_ALL',

	APPLE_USER_LOGIN_REQUEST: 'APPLE_USER_LOGIN_REQUEST',
	APPLE_USER_LOGIN_SUCCESS: 'APPLE_USER_LOGIN_SUCCESS',
	APPLE_USER_LOGIN_FAILURE: 'APPLE_USER_LOGIN_FAILURE',
	APPLE_USER_LOGIN_RESET: 'APPLE_USER_LOGIN_RESET',
	APPLE_USER_LOGIN_RESET_ALL: 'APPLE_USER_LOGIN_RESET_ALL',

	GET_USER_INFO_REQUEST: 'GET_USER_INFO_REQUEST',
	GET_USER_INFO_SUCCESS: 'GET_USER_INFO_SUCCESS',
	GET_USER_INFO_FAILURE: 'GET_USER_INFO_FAILURE',
	GET_USER_INFO_RESET: 'GET_USER_INFO_RESET',
	GET_USER_INFO_RESET_ALL: 'GET_USER_INFO_RESET_ALL',

	CREATE_USER_REQUEST: 'CREATE_USER_REQUEST',
	CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
	CREATE_USER_FAILURE: 'CREATE_USER_FAILURE',
	CREATE_USER_RESET: 'CREATE_USER_RESET',
	CREATE_USER_RESET_ALL: 'CREATE_USER_RESET_ALL',

	VERIFY_OTP_AND_CREATE_USER_REQUEST: 'VERIFY_OTP_AND_CREATE_USER_REQUEST',
	VERIFY_OTP_AND_CREATE_USER_SUCCESS: 'VERIFY_OTP_AND_CREATE_USER_SUCCESS',
	VERIFY_OTP_AND_CREATE_USER_FAILURE: 'VERIFY_OTP_AND_CREATE_USER_FAILURE',
	VERIFY_OTP_AND_CREATE_USER_RESET: 'VERIFY_OTP_AND_CREATE_USER_RESET',
	VERIFY_OTP_AND_CREATE_USER_RESET_ALL: 'VERIFY_OTP_AND_CREATE_USER_RESET_ALL',

	SEND_OTP_FOR_FORGET_PASSWORD_REQUEST: 'SEND_OTP_FOR_FORGET_PASSWORD_REQUEST',
	SEND_OTP_FOR_FORGET_PASSWORD_SUCCESS: 'SEND_OTP_FOR_FORGET_PASSWORD_SUCCESS',
	SEND_OTP_FOR_FORGET_PASSWORD_FAILURE: 'SEND_OTP_FOR_FORGET_PASSWORD_FAILURE',
	SEND_OTP_FOR_FORGET_PASSWORD_RESET: 'SEND_OTP_FOR_FORGET_PASSWORD_RESET',
	SEND_OTP_FOR_FORGET_PASSWORD_RESET_ALL: 'SEND_OTP_FOR_FORGET_PASSWORD_RESET_ALL',

	VERIFY_OTP_FOR_FORGET_PASSWORD_REQUEST: 'VERIFY_OTP_FOR_FORGET_PASSWORD_REQUEST',
	VERIFY_OTP_FOR_FORGET_PASSWORD_SUCCESS: 'VERIFY_OTP_FOR_FORGET_PASSWORD_SUCCESS',
	VERIFY_OTP_FOR_FORGET_PASSWORD_FAILURE: 'VERIFY_OTP_FOR_FORGET_PASSWORD_FAILURE',
	VERIFY_OTP_FOR_FORGET_PASSWORD_RESET: 'VERIFY_OTP_FOR_FORGET_PASSWORD_RESET',
	VERIFY_OTP_FOR_FORGET_PASSWORD_RESET_ALL: 'VERIFY_OTP_FOR_FORGET_PASSWORD_RESET_ALL',

	FORGET_PASSWORD_RESET_REQUEST: 'FORGET_PASSWORD_RESET_REQUEST',
	FORGET_PASSWORD_RESET_SUCCESS: 'FORGET_PASSWORD_RESET_SUCCESS',
	FORGET_PASSWORD_RESET_FAILURE: 'FORGET_PASSWORD_RESET_FAILURE',
	FORGET_PASSWORD_RESET_RESET: 'FORGET_PASSWORD_RESET_RESET',
	FORGET_PASSWORD_RESET_RESET_ALL: 'FORGET_PASSWORD_RESET_RESET_ALL',


	SEND_OTP_TO_CREATE_USER_REQUEST: 'SEND_OTP_TO_CREATE_USER_REQUEST',
	SEND_OTP_TO_CREATE_USER_SUCCESS: 'SEND_OTP_TO_CREATE_USER_SUCCESS',
	SEND_OTP_TO_CREATE_USER_FAILURE: 'SEND_OTP_TO_CREATE_USER_FAILURE',
	SEND_OTP_TO_CREATE_USER_RESET: 'SEND_OTP_TO_CREATE_USER_RESET',
	SEND_OTP_TO_CREATE_USER_RESET_ALL: 'SEND_OTP_TO_CREATE_USER_RESET_ALL',

	USER_LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
	USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
	USER_LOGIN_FAILURE: 'USER_LOGIN_FAILURE',
	USER_LOGIN_RESET: 'USER_LOGIN_RESET',
	USER_LOGIN_RESET_ALL: 'USER_LOGIN_RESET_ALL',

	VERIFY_OTP_FOR_LOGIN_REQUEST: 'VERIFY_OTP_FOR_LOGIN_REQUEST',
	VERIFY_OTP_FOR_LOGIN_SUCCESS: 'VERIFY_OTP_FOR_LOGIN_SUCCESS',
	VERIFY_OTP_FOR_LOGIN_FAILURE: 'VERIFY_OTP_FOR_LOGIN_FAILURE',
	VERIFY_OTP_FOR_LOGIN_RESET: 'VERIFY_OTP_FOR_LOGIN_RESET',
	VERIFY_OTP_FOR_LOGIN_RESET_ALL: 'VERIFY_OTP_FOR_LOGIN_RESET_ALL',

	GET_ALL_REGION_REQUEST: 'GET_ALL_REGION_REQUEST',
	GET_ALL_REGION_SUCCESS: 'GET_ALL_REGION_SUCCESS',
	GET_ALL_REGION_FAILURE: 'GET_ALL_REGION_FAILURE',
	GET_ALL_REGION_RESET: 'GET_ALL_REGION_RESET',
	GET_ALL_REGION_RESET_ALL: 'GET_ALL_REGION_RESET_ALL',

	GET_COUNTRY_BY_REGION_REQUEST: 'GET_COUNTRY_BY_REGION_REQUEST',
	GET_COUNTRY_BY_REGION_SUCCESS: 'GET_COUNTRY_BY_REGION_SUCCESS',
	GET_COUNTRY_BY_REGION_FAILURE: 'GET_COUNTRY_BY_REGION_FAILURE',
	GET_COUNTRY_BY_REGION_RESET: 'GET_COUNTRY_BY_REGION_RESET',
	GET_COUNTRY_BY_REGION_RESET_ALL: 'GET_COUNTRY_BY_REGION_RESET_ALL',


	GET_STATE_BY_COUNTRY_REQUEST: 'GET_STATE_BY_COUNTRY_REQUEST',
	GET_STATE_BY_COUNTRY_SUCCESS: 'GET_STATE_BY_COUNTRY_SUCCESS',
	GET_STATE_BY_COUNTRY_FAILURE: 'GET_STATE_BY_COUNTRY_FAILURE',
	GET_STATE_BY_COUNTRY_RESET: 'GET_STATE_BY_COUNTRY_RESET',
	GET_STATE_BY_COUNTRY_RESET_ALL: 'GET_STATE_BY_COUNTRY_RESET_ALL',

	GET_ALL_AGE_GROUP_REQUEST: 'GET_ALL_AGE_GROUP_REQUEST',
	GET_ALL_AGE_GROUP_SUCCESS: 'GET_ALL_AGE_GROUP_SUCCESS',
	GET_ALL_AGE_GROUP_FAILURE: 'GET_ALL_AGE_GROUP_FAILURE',
	GET_ALL_AGE_GROUP_RESET: 'GET_ALL_AGE_GROUP_RESET',
	GET_ALL_AGE_GROUP_RESET_ALL: 'GET_ALL_AGE_GROUP_RESET_ALL',


	GET_ALL_NICHE_REQUEST: 'GET_ALL_NICHE_REQUEST',
	GET_ALL_NICHE_SUCCESS: 'GET_ALL_NICHE_SUCCESS',
	GET_ALL_NICHE_FAILURE: 'GET_ALL_NICHE_FAILURE',
	GET_ALL_NICHE_RESET: 'GET_ALL_NICHE_RESET',
	GET_ALL_NICHE_RESET_ALL: 'GET_ALL_NICHE_RESET_ALL',


	GET_BUDGET_REQUEST: 'GET_BUDGET_REQUEST',
	GET_BUDGET_SUCCESS: 'GET_BUDGET_SUCCESS',
	GET_BUDGET_FAILURE: 'GET_BUDGET_FAILURE',
	GET_BUDGET_RESET: 'GET_BUDGET_RESET',
	GET_BUDGET_RESET_ALL: 'GET_BUDGET_RESET_ALL',

	GET_MAX_VIEWS_REQUEST: 'GET_MAX_VIEWS_REQUEST',
	GET_MAX_VIEWS_SUCCESS: 'GET_MAX_VIEWS_SUCCESS',
	GET_MAX_VIEWS_FAILURE: 'GET_MAX_VIEWS_FAILURE',
	GET_MAX_VIEWS_RESET: 'GET_MAX_VIEWS_RESET',
	GET_MAX_VIEWS_RESET_ALL: 'GET_MAX_VIEWS_RESET_ALL',


	GET_BRAND_CAMPAIGN_REQUEST: 'GET_BRAND_CAMPAIGN_REQUEST',
	GET_BRAND_CAMPAIGN_SUCCESS: 'GET_BRAND_CAMPAIGN_SUCCESS',
	GET_BRAND_CAMPAIGN_FAILURE: 'GET_BRAND_CAMPAIGN_FAILURE',
	GET_BRAND_CAMPAIGN_RESET: 'GET_BRAND_CAMPAIGN_RESET',
	GET_BRAND_CAMPAIGN_RESET_ALL: 'GET_BRAND_CAMPAIGN_RESET_ALL',

	GET_ALL_BANNER_TEMPLATE_REQUEST: 'GET_ALL_BANNER_TEMPLATE_REQUEST',
	GET_ALL_BANNER_TEMPLATE_SUCCESS: 'GET_ALL_BANNER_TEMPLATE_SUCCESS',
	GET_ALL_BANNER_TEMPLATE_FAILURE: 'GET_ALL_BANNER_TEMPLATE_FAILURE',
	GET_ALL_BANNER_TEMPLATE_RESET: 'GET_ALL_BANNER_TEMPLATE_RESET',
	GET_ALL_BANNER_TEMPLATE_RESET_ALL: 'GET_ALL_BANNER_TEMPLATE_RESET_ALL',


	UPLOAD_CAMPAIGN_FILE_REQUEST: 'UPLOAD_CAMPAIGN_FILE_REQUEST',
	UPLOAD_CAMPAIGN_FILE_SUCCESS: 'UPLOAD_CAMPAIGN_FILE_SUCCESS',
	UPLOAD_CAMPAIGN_FILE_FAILURE: 'UPLOAD_CAMPAIGN_FILE_FAILURE',
	UPLOAD_CAMPAIGN_FILE_RESET: 'UPLOAD_CAMPAIGN_FILE_RESET',
	UPLOAD_CAMPAIGN_FILE_RESET_ALL: 'UPLOAD_CAMPAIGN_FILE_RESET_ALL',

	CREATE_CAMPAIGN_REQUEST: 'CREATE_CAMPAIGN_REQUEST',
	CREATE_CAMPAIGN_SUCCESS: 'CREATE_CAMPAIGN_SUCCESS',
	CREATE_CAMPAIGN_FAILURE: 'CREATE_CAMPAIGN_FAILURE',
	CREATE_CAMPAIGN_RESET: 'CREATE_CAMPAIGN_RESET',
	CREATE_CAMPAIGN_RESET_ALL: 'CREATE_CAMPAIGN_RESET_ALL',

	GET_MY_BRAND_BUSINESS_REQUEST: 'GET_MY_BRAND_BUSINESS_REQUEST',
	GET_MY_BRAND_BUSINESS_SUCCESS: 'GET_MY_BRAND_BUSINESS_SUCCESS',
	GET_MY_BRAND_BUSINESS_FAILURE: 'GET_MY_BRAND_BUSINESS_FAILURE',
	GET_MY_BRAND_BUSINESS_RESET: 'GET_MY_BRAND_BUSINESS_RESET',
	GET_MY_BRAND_BUSINESS_RESET_ALL: 'GET_MY_BRAND_BUSINESS_RESET_ALL',

	SESRCH_BUSINESS_PLACES_REQUEST: 'SESRCH_BUSINESS_PLACES_REQUEST',
	SESRCH_BUSINESS_PLACES_SUCCESS: 'SESRCH_BUSINESS_PLACES_SUCCESS',
	SESRCH_BUSINESS_PLACES_FAILURE: 'SESRCH_BUSINESS_PLACES_FAILURE',
	SESRCH_BUSINESS_PLACES_RESET: 'SESRCH_BUSINESS_PLACES_RESET',
	SESRCH_BUSINESS_PLACES_RESET_ALL: 'SESRCH_BUSINESS_PLACES_RESET_ALL',

	REGISTER_BUSINESS_REQUEST: 'REGISTER_BUSINESS_REQUEST',
	REGISTER_BUSINESS_SUCCESS: 'REGISTER_BUSINESS_SUCCESS',
	REGISTER_BUSINESS_FAILURE: 'REGISTER_BUSINESS_FAILURE',
	REGISTER_BUSINESS_RESET: 'REGISTER_BUSINESS_RESET',
	REGISTER_BUSINESS_RESET_ALL: 'REGISTER_BUSINESS_RESET_ALL',

	MY_CHANNEL_LIST_REQUEST: 'MY_CHANNEL_LIST_REQUEST',
	MY_CHANNEL_LIST_SUCCESS: 'MY_CHANNEL_LIST_SUCCESS',
	MY_CHANNEL_LIST_FAILURE: 'MY_CHANNEL_LIST_FAILURE',
	MY_CHANNEL_LIST_RESET: 'MY_CHANNEL_LIST_RESET',
	MY_CHANNEL_LIST_RESET_ALL: 'MY_CHANNEL_LIST_RESET_ALL',

	STORE_YOUTUBE_AUTH_REQUEST: 'STORE_YOUTUBE_AUTH_REQUEST',
	STORE_YOUTUBE_AUTH_SUCCESS: 'STORE_YOUTUBE_AUTH_SUCCESS',
	STORE_YOUTUBE_AUTH_FAILURE: 'STORE_YOUTUBE_AUTH_FAILURE',
	STORE_YOUTUBE_AUTH_RESET: 'STORE_YOUTUBE_AUTH_RESET',
	STORE_YOUTUBE_AUTH_RESET_ALL: 'STORE_YOUTUBE_AUTH_RESET_ALL',

	GET_YOUTUBE_CHANNEL_LIST_REQUEST: 'GET_YOUTUBE_CHANNEL_LIST_REQUEST',
	GET_YOUTUBE_CHANNEL_LIST_SUCCESS: 'GET_YOUTUBE_CHANNEL_LIST_SUCCESS',
	GET_YOUTUBE_CHANNEL_LIST_FAILURE: 'GET_YOUTUBE_CHANNEL_LIST_FAILURE',
	GET_YOUTUBE_CHANNEL_LIST_RESET: 'GET_YOUTUBE_CHANNEL_LIST_RESET',
	GET_YOUTUBE_CHANNEL_LIST_RESET_ALL: 'GET_YOUTUBE_CHANNEL_LIST_RESET_ALL',

	STORE_VALIDATE_CHANNEL_REQUEST: 'STORE_VALIDATE_CHANNEL_REQUEST',
	STORE_VALIDATE_CHANNEL_SUCCESS: 'STORE_VALIDATE_CHANNEL_SUCCESS',
	STORE_VALIDATE_CHANNEL_FAILURE: 'STORE_VALIDATE_CHANNEL_FAILURE',
	STORE_VALIDATE_CHANNEL_RESET: 'STORE_VALIDATE_CHANNEL_RESET',
	STORE_VALIDATE_CHANNEL_RESET_ALL: 'STORE_VALIDATE_CHANNEL_RESET_ALL',


	GET_CAMPAIGN_LIST_FILTER_REQUEST: 'GET_CAMPAIGN_LIST_FILTER_REQUEST',
	GET_CAMPAIGN_LIST_FILTER_SUCCESS: 'GET_CAMPAIGN_LIST_FILTER_SUCCESS',
	GET_CAMPAIGN_LIST_FILTER_FAILURE: 'GET_CAMPAIGN_LIST_FILTER_FAILURE',
	GET_CAMPAIGN_LIST_FILTER_RESET: 'GET_CAMPAIGN_LIST_FILTER_RESET',
	GET_CAMPAIGN_LIST_FILTER_RESET_ALL: 'GET_CAMPAIGN_LIST_FILTER_RESET_ALL',


	UPLOAD_INFLUENCER_VIDEO_REQUEST: 'UPLOAD_INFLUENCER_VIDEO_REQUEST',
	UPLOAD_INFLUENCER_VIDEO_SUCCESS: 'UPLOAD_INFLUENCER_VIDEO_SUCCESS',
	UPLOAD_INFLUENCER_VIDEO_FAILURE: 'UPLOAD_INFLUENCER_VIDEO_FAILURE',
	UPLOAD_INFLUENCER_VIDEO_RESET: 'UPLOAD_INFLUENCER_VIDEO_RESET',
	UPLOAD_INFLUENCER_VIDEO_RESET_ALL: 'UPLOAD_INFLUENCER_VIDEO_RESET_ALL',

	STREAM_VIDEO_REQUEST: 'STREAM_VIDEO_REQUEST',
	STREAM_VIDEO_SUCCESS: 'STREAM_VIDEO_SUCCESS',
	STREAM_VIDEO_FAILURE: 'STREAM_VIDEO_FAILURE',
	STREAM_VIDEO_RESET: 'STREAM_VIDEO_RESET',
	STREAM_VIDEO_RESET_ALL: 'STREAM_VIDEO_RESET_ALL',

	OPT_AND_SUBMIT_CONTENT_REQUEST: 'OPT_AND_SUBMIT_CONTENT_REQUEST',
	OPT_AND_SUBMIT_CONTENT_SUCCESS: 'OPT_AND_SUBMIT_CONTENT_SUCCESS',
	OPT_AND_SUBMIT_CONTENT_FAILURE: 'OPT_AND_SUBMIT_CONTENT_FAILURE',
	OPT_AND_SUBMIT_CONTENT_RESET: 'OPT_AND_SUBMIT_CONTENT_RESET',
	OPT_AND_SUBMIT_CONTENT_RESET_ALL: 'OPT_AND_SUBMIT_CONTENT_RESET_ALL',

	CHECK_CONTENT_MERGE_STATUS_REQUEST: 'CHECK_CONTENT_MERGE_STATUS_REQUEST',
	CHECK_CONTENT_MERGE_STATUS_SUCCESS: 'CHECK_CONTENT_MERGE_STATUS_SUCCESS',
	CHECK_CONTENT_MERGE_STATUS_FAILURE: 'CHECK_CONTENT_MERGE_STATUS_FAILURE',
	CHECK_CONTENT_MERGE_STATUS_RESET: 'CHECK_CONTENT_MERGE_STATUS_RESET',
	CHECK_CONTENT_MERGE_STATUS_RESET_ALL: 'CHECK_CONTENT_MERGE_STATUS_RESET_ALL',

	PUBLISH_VIDEO_ON_YOUTUBE_REQUEST: 'PUBLISH_VIDEO_ON_YOUTUBE_REQUEST',
	PUBLISH_VIDEO_ON_YOUTUBE_SUCCESS: 'PUBLISH_VIDEO_ON_YOUTUBE_SUCCESS',
	PUBLISH_VIDEO_ON_YOUTUBE_FAILURE: 'PUBLISH_VIDEO_ON_YOUTUBE_FAILURE',
	PUBLISH_VIDEO_ON_YOUTUBE_RESET: 'PUBLISH_VIDEO_ON_YOUTUBE_RESET',
	PUBLISH_VIDEO_ON_YOUTUBE_RESET_ALL: 'PUBLISH_VIDEO_ON_YOUTUBE_RESET_ALL',

	RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_REQUEST: 'RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_REQUEST',
	RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_SUCCESS: 'RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_SUCCESS',
	RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_FAILURE: 'RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_FAILURE',
	RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_RESET: 'RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_RESET',
	RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_RESET_ALL: 'RESUBMISSION_OPT_AND_SUBMIT_CONTENT_UGC_RESET_ALL',

	UPLOAD_TO_S3_REQUEST: 'UPLOAD_TO_S3_REQUEST',
	UPLOAD_TO_S3_SUCCESS: 'UPLOAD_TO_S3_SUCCESS',
	UPLOAD_TO_S3_FAILURE: 'UPLOAD_TO_S3_FAILURE',
	UPLOAD_TO_S3_RESET: 'UPLOAD_TO_S3_RESET',
	UPLOAD_TO_S3_RESET_ALL: 'UPLOAD_TO_S3_RESET_ALL',




	GET_UPLOADED_UGC_CONTENT_LIST_REQUEST: 'GET_UPLOADED_UGC_CONTENT_LIST_REQUEST',
	GET_UPLOADED_UGC_CONTENT_LIST_SUCCESS: 'GET_UPLOADED_UGC_CONTENT_LIST_SUCCESS',
	GET_UPLOADED_UGC_CONTENT_LIST_FAILURE: 'GET_UPLOADED_UGC_CONTENT_LIST_FAILURE',
	GET_UPLOADED_UGC_CONTENT_LIST_RESET: 'GET_UPLOADED_UGC_CONTENT_LIST_RESET',
	GET_UPLOADED_UGC_CONTENT_LIST_RESET_ALL: 'GET_UPLOADED_UGC_CONTENT_LIST_RESET_ALL',

	MARK_APPROVED_REJECTED_CONTENT_REQUEST: 'MARK_APPROVED_REJECTED_CONTENT_REQUEST',
	MARK_APPROVED_REJECTED_CONTENT_SUCCESS: 'MARK_APPROVED_REJECTED_CONTENT_SUCCESS',
	MARK_APPROVED_REJECTED_CONTENT_FAILURE: 'MARK_APPROVED_REJECTED_CONTENT_FAILURE',
	MARK_APPROVED_REJECTED_CONTENT_RESET: 'MARK_APPROVED_REJECTED_CONTENT_RESET',
	MARK_APPROVED_REJECTED_CONTENT_RESET_ALL: 'MARK_APPROVED_REJECTED_CONTENT_RESET_ALL',

	GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_REQUEST: 'GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_REQUEST',
	GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_SUCCESS: 'GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_SUCCESS',
	GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_FAILURE: 'GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_FAILURE',
	GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_RESET: 'GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_RESET',
	GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_RESET_ALL: 'GET_UPLOADED_UGC_CONTENT_FOR_INFLUENCER_RESET_ALL',

	GET_WALLET_TXN_WITH_FILTER_REQUEST: 'GET_WALLET_TXN_WITH_FILTER_REQUEST',
	GET_WALLET_TXN_WITH_FILTER_SUCCESS: 'GET_WALLET_TXN_WITH_FILTER_SUCCESS',
	GET_WALLET_TXN_WITH_FILTER_FAILURE: 'GET_WALLET_TXN_WITH_FILTER_FAILURE',
	GET_WALLET_TXN_WITH_FILTER_RESET: 'GET_WALLET_TXN_WITH_FILTER_RESET',
	GET_WALLET_TXN_WITH_FILTER_RESET_ALL: 'GET_WALLET_TXN_WITH_FILTER_RESET_ALL',

	ADD_MONEY_TO_WALLET_REQUEST: 'ADD_MONEY_TO_WALLET_REQUEST',
	ADD_MONEY_TO_WALLET_SUCCESS: 'ADD_MONEY_TO_WALLET_SUCCESS',
	ADD_MONEY_TO_WALLET_FAILURE: 'ADD_MONEY_TO_WALLET_FAILURE',
	ADD_MONEY_TO_WALLET_RESET: 'ADD_MONEY_TO_WALLET_RESET',
	ADD_MONEY_TO_WALLET_RESET_ALL: 'ADD_MONEY_TO_WALLET_RESET_ALL',

	TXN_STATUS_REQUEST: 'TXN_STATUS_REQUEST',
	TXN_STATUS_SUCCESS: 'TXN_STATUS_SUCCESS',
	TXN_STATUS_FAILURE: 'TXN_STATUS_FAILURE',
	TXN_STATUS_RESET: 'TXN_STATUS_RESET',
	TXN_STATUS_RESET_ALL: 'TXN_STATUS_RESET_ALL',

	STRIPE_ONBOARDING_REQUEST: 'STRIPE_ONBOARDING_REQUEST',
	STRIPE_ONBOARDING_SUCCESS: 'STRIPE_ONBOARDING_SUCCESS',
	STRIPE_ONBOARDING_FAILURE: 'STRIPE_ONBOARDING_FAILURE',
	STRIPE_ONBOARDING_RESET: 'STRIPE_ONBOARDING_RESET',
	STRIPE_ONBOARDING_RESET_ALL: 'STRIPE_ONBOARDING_RESET_ALL',

	CHECK_STRIPE_ONBOARDING_STATUS_REQUEST: 'CHECK_STRIPE_ONBOARDING_STATUS_REQUEST',
	CHECK_STRIPE_ONBOARDING_STATUS_SUCCESS: 'CHECK_STRIPE_ONBOARDING_STATUS_SUCCESS',
	CHECK_STRIPE_ONBOARDING_STATUS_FAILURE: 'CHECK_STRIPE_ONBOARDING_STATUS_FAILURE',
	CHECK_STRIPE_ONBOARDING_STATUS_RESET: 'CHECK_STRIPE_ONBOARDING_STATUS_RESET',
	CHECK_STRIPE_ONBOARDING_STATUS_RESET_ALL: 'CHECK_STRIPE_ONBOARDING_STATUS_RESET_ALL',

	REQUEST_PAYOUT_REQUEST: 'REQUEST_PAYOUT_REQUEST',
	REQUEST_PAYOUT_SUCCESS: 'REQUEST_PAYOUT_SUCCESS',
	REQUEST_PAYOUT_FAILURE: 'REQUEST_PAYOUT_FAILURE',
	REQUEST_PAYOUT_RESET: 'REQUEST_PAYOUT_RESET',
	REQUEST_PAYOUT_RESET_ALL: 'REQUEST_PAYOUT_RESET_ALL',

	GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_REQUEST: 'GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_REQUEST',
	GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_SUCCESS: 'GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_SUCCESS',
	GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_FAILURE: 'GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_FAILURE',
	GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_RESET: 'GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_RESET',
	GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_RESET_ALL: 'GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_RESET_ALL',

	GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_REQUEST: 'GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_REQUEST',
	GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_SUCCESS: 'GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_SUCCESS',
	GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_FAILURE: 'GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_FAILURE',
	GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_RESET: 'GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_RESET',
	GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_RESET_ALL: 'GET_POTENTIAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_RESET_ALL',

	GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_REQUEST: 'GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_REQUEST',
	GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_SUCCESS: 'GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_SUCCESS',
	GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_FAILURE: 'GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_FAILURE',
	GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_RESET: 'GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_RESET',
	GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_RESET_ALL: 'GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_RESET_ALL',

	GET_DASHBOARD_DATA_REQUEST: 'GET_DASHBOARD_DATA_REQUEST',
	GET_DASHBOARD_DATA_SUCCESS: 'GET_DASHBOARD_DATA_SUCCESS',
	GET_DASHBOARD_DATA_FAILURE: 'GET_DASHBOARD_DATA_FAILURE',
	GET_DASHBOARD_DATA_RESET: 'GET_DASHBOARD_DATA_RESET',
	GET_DASHBOARD_DATA_RESET_ALL: 'GET_DASHBOARD_DATA_RESET_ALL',

	GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_REQUEST: 'GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_REQUEST',
	GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_SUCCESS: 'GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_SUCCESS',
	GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_FAILURE: 'GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_FAILURE',
	GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_RESET: 'GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_RESET',
	GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_RESET_ALL: 'GET_CAMPAIGN_LIST_WITH_FILTER_DASHBOARD_RESET_ALL',

	GET_CONFIG_PROPERTIES_VALUE_REQUEST: 'GET_CONFIG_PROPERTIES_VALUE_REQUEST',
	GET_CONFIG_PROPERTIES_VALUE_SUCCESS: 'GET_CONFIG_PROPERTIES_VALUE_SUCCESS',
	GET_CONFIG_PROPERTIES_VALUE_FAILURE: 'GET_CONFIG_PROPERTIES_VALUE_FAILURE',
	GET_CONFIG_PROPERTIES_VALUE_RESET: 'GET_CONFIG_PROPERTIES_VALUE_RESET',
	GET_CONFIG_PROPERTIES_VALUE_RESET_ALL: 'GET_CONFIG_PROPERTIES_VALUE_RESET_ALL',

	GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_REQUEST: 'GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_REQUEST',
	GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_SUCCESS: 'GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_SUCCESS',
	GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_FAILURE: 'GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_FAILURE',
	GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_RESET: 'GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_RESET',
	GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_RESET_ALL: 'GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_RESET_ALL',

	OPT_CAMPAIGN_NOT_PUBLISHED_REQUEST: 'OPT_CAMPAIGN_NOT_PUBLISHED_REQUEST',
	OPT_CAMPAIGN_NOT_PUBLISHED_SUCCESS: 'OPT_CAMPAIGN_NOT_PUBLISHED_SUCCESS',
	OPT_CAMPAIGN_NOT_PUBLISHED_FAILURE: 'OPT_CAMPAIGN_NOT_PUBLISHED_FAILURE',
	OPT_CAMPAIGN_NOT_PUBLISHED_RESET: 'OPT_CAMPAIGN_NOT_PUBLISHED_RESET',
	OPT_CAMPAIGN_NOT_PUBLISHED_RESET_ALL: 'OPT_CAMPAIGN_NOT_PUBLISHED_RESET_ALL',

	GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_REQUEST: 'GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_REQUEST',
    GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_SUCCESS: 'GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_SUCCESS',
    GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_FAILURE: 'GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_FAILURE',
    GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_RESET: 'GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_RESET',
	GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_RESET_ALL: 'GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_RESET_ALL',

	GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_REQUEST: 'GET_OPTSED_CAMPAIGNS_DETAILS_BY_INFLUENCER_REQUEST',
    GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_SUCCESS: 'GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_SUCCESS',
    GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_FAILURE: 'GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_FAILURE',
    GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_RESET: 'GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_RESET',
	GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_RESET_ALL: 'GET_OPTED_CAMPAIGNS_DETAILS_BY_INFLUENCER_RESET_ALL',

	OPT_UGC_CAMPAIGN_REQUEST: 'OPT_UGC_CAMPAIGN_REQUEST',
    OPT_UGC_CAMPAIGN_SUCCESS: 'OPT_UGC_CAMPAIGN_SUCCESS',
    OPT_UGC_CAMPAIGN_FAILURE: 'OPT_UGC_CAMPAIGN_FAILURE',
    OPT_UGC_CAMPAIGN_RESET: 'OPT_UGC_CAMPAIGN_RESET',
    OPT_UGC_CAMPAIGN_RESET_ALL: 'OPT_UGC_CAMPAIGN_RESET_ALL',

	VIEW_UGC_CONTENT_FOR_INFLUENCER_REQUEST: 'VIEW_UGC_CONTENT_FOR_INFLUENCER_REQUEST',
    VIEW_UGC_CONTENT_FOR_INFLUENCER_SUCCESS: 'VIEW_UGC_CONTENT_FOR_INFLUENCER_SUCCESS',
    VIEW_UGC_CONTENT_FOR_INFLUENCER_FAILURE: 'VIEW_UGC_CONTENT_FOR_INFLUENCER_FAILURE',
    VIEW_UGC_CONTENT_FOR_INFLUENCER_RESET: 'VIEW_UGC_CONTENT_FOR_INFLUENCER_RESET',
    VIEW_UGC_CONTENT_FOR_INFLUENCER_RESET_ALL: 'VIEW_UGC_CONTENT_FOR_INFLUENCER_RESET_ALL',

	SEND_OTP_FOR_MOBILE_VERIFIED_REQUEST: 'SEND_OTP_FOR_MOBILE_VERIFIED_REQUEST',
    SEND_OTP_FOR_MOBILE_VERIFIED_SUCCESS: 'SEND_OTP_FOR_MOBILE_VERIFIED_SUCCESS',
    SEND_OTP_FOR_MOBILE_VERIFIED_FAILURE: 'SEND_OTP_FOR_MOBILE_VERIFIED_FAILURE',
    SEND_OTP_FOR_MOBILE_VERIFIED_RESET: 'SEND_OTP_FOR_MOBILE_VERIFIED_RESET',
    SEND_OTP_FOR_MOBILE_VERIFIED_RESET_ALL: 'SEND_OTP_FOR_MOBILE_VERIFIED_RESET_ALL',

	// verifyMobileOtp
	VERIFY_MOBILE_OTP_REQUEST: 'VERIFY_MOBILE_OTP_REQUEST',
    VERIFY_MOBILE_OTP_SUCCESS: 'VERIFY_MOBILE_OTP_SUCCESS',
    VERIFY_MOBILE_OTP_FAILURE: 'VERIFY_MOBILE_OTP_FAILURE',
    VERIFY_MOBILE_OTP_RESET: 'VERIFY_MOBILE_OTP_RESET',
    VERIFY_MOBILE_OTP_RESET_ALL: 'VERIFY_MOBILE_OTP_RESET_ALL',

	// loggedInInfluencerChannelList
	LOGGED_IN_INFLUENCER_CHANNEL_LIST_REQUEST: 'LOGGED_IN_INFLUENCER_CHANNEL_LIST_REQUEST',
    LOGGED_IN_INFLUENCER_CHANNEL_LIST_SUCCESS: 'LOGGED_IN_INFLUENCER_CHANNEL_LIST_SUCCESS',
    LOGGED_IN_INFLUENCER_CHANNEL_LIST_FAILURE: 'LOGGED_IN_INFLUENCER_CHANNEL_LIST_FAILURE',
    LOGGED_IN_INFLUENCER_CHANNEL_LIST_RESET: 'LOGGED_IN_INFLUENCER_CHANNEL_LIST_RESET',
    LOGGED_IN_INFLUENCER_CHANNEL_LIST_RESET_ALL: 'LOGGED_IN_INFLUENCER_CHANNEL_LIST_RESET_ALL',

	// downloadContentForManualUpload
	DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_REQUEST: 'DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_REQUEST',
    DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_SUCCESS: 'DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_SUCCESS',
    DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_FAILURE: 'DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_FAILURE',
    DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_RESET: 'DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_RESET',
    DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_RESET_ALL: 'DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_RESET_ALL',

	// optAndSubmitContentLink
	OPT_AND_SUBMIT_CONTENT_LINK_REQUEST: 'OPT_AND_SUBMIT_CONTENT_LINK_REQUEST',
    OPT_AND_SUBMIT_CONTENT_LINK_SUCCESS: 'OPT_AND_SUBMIT_CONTENT_LINK_SUCCESS',
    OPT_AND_SUBMIT_CONTENT_LINK_FAILURE: 'OPT_AND_SUBMIT_CONTENT_LINK_FAILURE',
    OPT_AND_SUBMIT_CONTENT_LINK_RESET: 'OPT_AND_SUBMIT_CONTENT_LINK_RESET',
    OPT_AND_SUBMIT_CONTENT_LINK_RESET_ALL: 'OPT_AND_SUBMIT_CONTENT_LINK_RESET_ALL',

	// sendOtpToCreateAgency
	SEND_OTP_TO_CREATE_AGENCY_REQUEST: 'SEND_OTP_TO_CREATE_AGENCY_REQUEST',
    SEND_OTP_TO_CREATE_AGENCY_SUCCESS: 'SEND_OTP_TO_CREATE_AGENCY_SUCCESS',
    SEND_OTP_TO_CREATE_AGENCY_FAILURE: 'SEND_OTP_TO_CREATE_AGENCY_FAILURE',
    SEND_OTP_TO_CREATE_AGENCY_RESET: 'SEND_OTP_TO_CREATE_AGENCY_RESET',
    SEND_OTP_TO_CREATE_AGENCY_RESET_ALL: 'SEND_OTP_TO_CREATE_AGENCY_RESET_ALL',

	// verifyOtpAndCreateAgencyUser
	VERIFY_OTP_AND_CREATE_AGENCY_USER_REQUEST: 'VERIFY_OTP_AND_CREATE_AGENCY_USER_REQUEST',
    VERIFY_OTP_AND_CREATE_AGENCY_USER_SUCCESS: 'VERIFY_OTP_AND_CREATE_AGENCY_USER_SUCCESS',
    VERIFY_OTP_AND_CREATE_AGENCY_USER_FAILURE: 'VERIFY_OTP_AND_CREATE_AGENCY_USER_FAILURE',
    VERIFY_OTP_AND_CREATE_AGENCY_USER_RESET: 'VERIFY_OTP_AND_CREATE_AGENCY_USER_RESET',
    VERIFY_OTP_AND_CREATE_AGENCY_USER_RESET_ALL: 'VERIFY_OTP_AND_CREATE_AGENCY_USER_RESET_ALL',

	// createCampaignByAgency
	CREATE_CAMPAIGN_BY_AGENCY_REQUEST: 'CREATE_CAMPAIGN_BY_AGENCY_REQUEST',
    CREATE_CAMPAIGN_BY_AGENCY_SUCCESS: 'CREATE_CAMPAIGN_BY_AGENCY_SUCCESS',
    CREATE_CAMPAIGN_BY_AGENCY_FAILURE: 'CREATE_CAMPAIGN_BY_AGENCY_FAILURE',
    CREATE_CAMPAIGN_BY_AGENCY_RESET: 'CREATE_CAMPAIGN_BY_AGENCY_RESET',
    CREATE_CAMPAIGN_BY_AGENCY_RESET_ALL: 'CREATE_CAMPAIGN_BY_AGENCY_RESET_ALL',

	// getAllAgencyUser
	GET_ALL_AGENCY_USER_REQUEST: 'GET_ALL_AGENCY_USER_REQUEST',
    GET_ALL_AGENCY_USER_SUCCESS: 'GET_ALL_AGENCY_USER_SUCCESS',
    GET_ALL_AGENCY_USER_FAILURE: 'GET_ALL_AGENCY_USER_FAILURE',
    GET_ALL_AGENCY_USER_RESET: 'GET_ALL_AGENCY_USER_RESET',
    GET_ALL_AGENCY_USER_RESET_ALL: 'GET_ALL_AGENCY_USER_RESET_ALL',

	// markActiveInActiveAgencyUser
	MARK_ACTIVE_INACTIVE_AGENCY_USER_REQUEST: 'MARK_ACTIVE_INACTIVE_AGENCY_USER_REQUEST',
    MARK_ACTIVE_INACTIVE_AGENCY_USER_SUCCESS: 'MARK_ACTIVE_INACTIVE_AGENCY_USER_SUCCESS',
    MARK_ACTIVE_INACTIVE_AGENCY_USER_FAILURE: 'MARK_ACTIVE_INACTIVE_AGENCY_USER_FAILURE',
    MARK_ACTIVE_INACTIVE_AGENCY_USER_RESET: 'MARK_ACTIVE_INACTIVE_AGENCY_USER_RESET',
    MARK_ACTIVE_INACTIVE_AGENCY_USER_RESET_ALL: 'MARK_ACTIVE_INACTIVE_AGENCY_USER_RESET_ALL',

	// createAgencyUser
	CREATE_AGENCY_USER_REQUEST: 'CREATE_AGENCY_USER_REQUEST',
    CREATE_AGENCY_USER_SUCCESS: 'CREATE_AGENCY_USER_SUCCESS',
    CREATE_AGENCY_USER_FAILURE: 'CREATE_AGENCY_USER_FAILURE',
    CREATE_AGENCY_USER_RESET: 'CREATE_AGENCY_USER_RESET',
    CREATE_AGENCY_USER_RESET_ALL: 'CREATE_AGENCY_USER_RESET_ALL',

	// getMyBrandBusinessDetailForAgency
	GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_REQUEST: 'GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_REQUEST',
    GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_SUCCESS: 'GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_SUCCESS',
    GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_FAILURE: 'GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_FAILURE',
    GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_RESET: 'GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_RESET',
    GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_RESET_ALL: 'GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_RESET_ALL',

	// searchBusinessPlaceForAgency
	SEARCH_BUSINESS_PLACE_FOR_AGENCY_REQUEST: 'SEARCH_BUSINESS_PLACE_FOR_AGENCY_REQUEST',
    SEARCH_BUSINESS_PLACE_FOR_AGENCY_SUCCESS: 'SEARCH_BUSINESS_PLACE_FOR_AGENCY_SUCCESS',
    SEARCH_BUSINESS_PLACE_FOR_AGENCY_FAILURE: 'SEARCH_BUSINESS_PLACE_FOR_AGENCY_FAILURE',
    SEARCH_BUSINESS_PLACE_FOR_AGENCY_RESET: 'SEARCH_BUSINESS_PLACE_FOR_AGENCY_RESET',
    SEARCH_BUSINESS_PLACE_FOR_AGENCY_RESET_ALL: 'SEARCH_BUSINESS_PLACE_FOR_AGENCY_RESET_ALL',

	// createBrandByAgency
	CREATE_BRAND_BY_AGENCY_REQUEST: 'CREATE_BRAND_BY_AGENCY_REQUEST',
    CREATE_BRAND_BY_AGENCY_SUCCESS: 'CREATE_BRAND_BY_AGENCY_SUCCESS',
    CREATE_BRAND_BY_AGENCY_FAILURE: 'CREATE_BRAND_BY_AGENCY_FAILURE',
    CREATE_BRAND_BY_AGENCY_RESET: 'CREATE_BRAND_BY_AGENCY_RESET',
    CREATE_BRAND_BY_AGENCY_RESET_ALL: 'CREATE_BRAND_BY_AGENCY_RESET_ALL',

	// getWalletTxnWithFilterForAgency
	GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_REQUEST: 'GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_REQUEST',
    GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_SUCCESS: 'GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_SUCCESS',
    GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_FAILURE: 'GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_FAILURE',
    GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_RESET: 'GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_RESET',
    GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_RESET_ALL: 'GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_RESET_ALL',

	// getCityByState
	GET_CITY_BY_STATE_REQUEST: 'GET_CITY_BY_STATE_REQUEST',
	GET_CITY_BY_STATE_SUCCESS: 'GET_CITY_BY_STATE_SUCCESS',
	GET_CITY_BY_STATE_FAILURE: 'GET_CITY_BY_STATE_FAILURE',
	GET_CITY_BY_STATE_RESET: 'GET_CITY_BY_STATE_RESET',
	GET_CITY_BY_STATE_RESET_ALL: 'GET_CITY_BY_STATE_RESET_ALL',

	// uploadReferenceVideo
	UPLOAD_REFERENCE_VIDEO_REQUEST: 'UPLOAD_REFERENCE_VIDEO_REQUEST',
	UPLOAD_REFERENCE_VIDEO_SUCCESS: 'UPLOAD_REFERENCE_VIDEO_SUCCESS',
	UPLOAD_REFERENCE_VIDEO_FAILURE: 'UPLOAD_REFERENCE_VIDEO_FAILURE',
	UPLOAD_REFERENCE_VIDEO_RESET: 'UPLOAD_REFERENCE_VIDEO_RESET',
	UPLOAD_REFERENCE_VIDEO_RESET_ALL: 'UPLOAD_REFERENCE_VIDEO_RESET_ALL',

	// downloadReferenceVideo
	DOWNLOAD_REFERENCE_VIDEO_REQUEST: 'DOWNLOAD_REFERENCE_VIDEO_REQUEST',
	DOWNLOAD_REFERENCE_VIDEO_SUCCESS: 'DOWNLOAD_REFERENCE_VIDEO_SUCCESS',
	DOWNLOAD_REFERENCE_VIDEO_FAILURE: 'DOWNLOAD_REFERENCE_VIDEO_FAILURE',
	DOWNLOAD_REFERENCE_VIDEO_RESET: 'DOWNLOAD_REFERENCE_VIDEO_RESET',
	DOWNLOAD_REFERENCE_VIDEO_RESET_ALL: 'DOWNLOAD_REFERENCE_VIDEO_RESET_ALL',

	// getInfluencerProfile
	GET_INFLUENCER_PROFILE_REQUEST: 'GET_INFLUENCER_PROFILE_REQUEST',
	GET_INFLUENCER_PROFILE_SUCCESS: 'GET_INFLUENCER_PROFILE_SUCCESS',
	GET_INFLUENCER_PROFILE_FAILURE: 'GET_INFLUENCER_PROFILE_FAILURE',
	GET_INFLUENCER_PROFILE_RESET: 'GET_INFLUENCER_PROFILE_RESET',
	GET_INFLUENCER_PROFILE_RESET_ALL: 'GET_INFLUENCER_PROFILE_RESET_ALL',

	// saveInfluencerProfile
	SAVE_INFLUENCER_PROFILE_REQUEST: 'SAVE_INFLUENCER_PROFILE_REQUEST',
	SAVE_INFLUENCER_PROFILE_SUCCESS: 'SAVE_INFLUENCER_PROFILE_SUCCESS',
	SAVE_INFLUENCER_PROFILE_FAILURE: 'SAVE_INFLUENCER_PROFILE_FAILURE',
	SAVE_INFLUENCER_PROFILE_RESET: 'SAVE_INFLUENCER_PROFILE_RESET',
	SAVE_INFLUENCER_PROFILE_RESET_ALL: 'SAVE_INFLUENCER_PROFILE_RESET_ALL',

	// updateUserInfo
	UPDATE_USER_INFO_REQUEST: 'UPDATE_USER_INFO_REQUEST',
	UPDATE_USER_INFO_SUCCESS: 'UPDATE_USER_INFO_SUCCESS',
	UPDATE_USER_INFO_FAILURE: 'UPDATE_USER_INFO_FAILURE',
	UPDATE_USER_INFO_RESET: 'UPDATE_USER_INFO_RESET',

	// uploadProfilePhoto
	UPLOAD_PROFILE_PHOTO_REQUEST: 'UPLOAD_PROFILE_PHOTO_REQUEST',
	UPLOAD_PROFILE_PHOTO_SUCCESS: 'UPLOAD_PROFILE_PHOTO_SUCCESS',
	UPLOAD_PROFILE_PHOTO_FAILURE: 'UPLOAD_PROFILE_PHOTO_FAILURE',
	UPLOAD_PROFILE_PHOTO_RESET: 'UPLOAD_PROFILE_PHOTO_RESET',
	UPLOAD_PROFILE_PHOTO_RESET_ALL: 'UPLOAD_PROFILE_PHOTO_RESET_ALL',

	// deactivateAccount
	DEACTIVATE_ACCOUNT_REQUEST: 'DEACTIVATE_ACCOUNT_REQUEST',
	DEACTIVATE_ACCOUNT_SUCCESS: 'DEACTIVATE_ACCOUNT_SUCCESS',
	DEACTIVATE_ACCOUNT_FAILURE: 'DEACTIVATE_ACCOUNT_FAILURE',
	DEACTIVATE_ACCOUNT_RESET: 'DEACTIVATE_ACCOUNT_RESET',
}

